// extracted by mini-css-extract-plugin
export default {"nhima-header":"NhimaReport_nhima-header__+kOlM","divider":"NhimaReport_divider__OaDh7"};